import { MdIosShare } from "react-icons/md";
import {
  Button,
  Input,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverHeader,
  PopoverTrigger,
} from "@chakra-ui/react";

interface Props {
  background: string;
  color: string;
  hoverColor: string;
  link: string;
}

export default function ShareButton(props: Props) {
  return (
    <Popover>
      <PopoverTrigger>
        <Button
          _hover={{ background: props.background, color: props.hoverColor }}
          size="md"
          background={props.background}
          color={props.color}
        >
          <MdIosShare fontSize={20} />
        </Button>
      </PopoverTrigger>
      <PopoverContent>
        <PopoverArrow />
        <PopoverCloseButton />
        <PopoverHeader>Share Link</PopoverHeader>
        <PopoverBody>
          <Input
            mt={2}
            mb={4}
            fontSize="xs"
            cursor="text!important"
            readOnly
            value={props.link}
            onClick={(e: any) => {
              e.target.select();
            }}
          />
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
}
